module.exports = __webpack_public_path__ + "static/media/wine-toast-1600x1067.9551e846.jpg";